/** Same name the vehicle list shows, plus the plate and code so either can be typed. */
export interface ReportVehicleRow {
  vehicle_id: number
  vehicle_source: string
  vehicle_code?: string | null
  license_plate?: string | null
  custom_name?: string | null
  customer_name?: string | null
  brand?: string | null
  make?: string | null
  model?: string | null
}

const clean = (value: unknown) => String(value || '').trim()

export function reportVehicleOption(vehicle: ReportVehicleRow) {
  const isAsset = vehicle.vehicle_source === 'ASSET'
  const plate = isAsset ? clean(vehicle.license_plate) : ''
  const code = clean(vehicle.vehicle_code)
  const customName = clean(vehicle.custom_name)
  const brand = clean(vehicle.brand || vehicle.make)
  const model = clean(vehicle.model)
  const brandModel = [brand, model].filter(Boolean).join(' ')
  const brandModelHyphen = [brand, model].filter(Boolean).join('-')
  const name = isAsset
    ? (customName || brandModel || plate || code || `#${vehicle.vehicle_id}`)
    : (customName || code || `#${vehicle.vehicle_id}`)
  const hint = [plate, code, brand, model, brandModel, brandModelHyphen, vehicle.customer_name]
    .map(clean)
    .filter((value, index, all) => value && value.toLowerCase() !== name.toLowerCase() && all.findIndex(item => item.toLowerCase() === value.toLowerCase()) === index)
    .join(' · ')
  return {
    value: `${vehicle.vehicle_source}:${vehicle.vehicle_id}`,
    label: name,
    hint: hint || null
  }
}
